import { useState } from "react";

function getRandomY() {
  return Math.floor(Math.random() * 90) + "vh";
}

function getRandomSpeed() {
  return Math.floor(Math.random() * 4) + 5;
}

function removeFromArray(array, element) {
  const index = array.indexOf(element);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
}

export default function FloatingWord({ word }) {
  const [classes, setClasses] = useState(["floatingWord", "moveLeft"]);
  const [animationSpeed, setAnimationSpeed] = useState(getRandomSpeed());
  const [top, setTop] = useState(getRandomY());

  return (
    <div
      style={{ top, animationDuration: animationSpeed + "s" }}
      className={classes.join(" ")}
      onAnimationEnd={() => {
        const newClasses = JSON.parse(JSON.stringify(classes));

        if (classes.includes("moveRight")) {
          removeFromArray(newClasses, "moveRight");
          newClasses.push("moveLeft");
        } else if (classes.includes("moveLeft")) {
          removeFromArray(newClasses, "moveLeft");
          newClasses.push("moveRight");
        } else {
          newClasses.push("moveLeft");
        }

        const newSpeed = getRandomSpeed();

        setClasses(newClasses);
        setAnimationSpeed(newSpeed);
        setTop(getRandomY());
      }}
    >
      {word}
    </div>
  );
}
